import { isMobile, isTablet } from 'mobile-device-detect'
import { SortingField } from '../../../../../graphql/generated'
import { GalleryLayout, GroupedBy } from '../../../components/types'

const mobileZoom = isTablet ? 4 : 2

export interface GallerySettings {
  sortBy: {
    field: SortingField
    desc: boolean
  }
  groupedBy: GroupedBy
  layout: GalleryLayout
  flatten: boolean
  zoom: number
  cropMode: boolean
}

export const initialGallerySettings: GallerySettings = {
  sortBy: {
    field: SortingField.DateTaken,
    desc: true
  },
  groupedBy: GroupedBy.All_Photos,
  layout: GalleryLayout.Grid,
  flatten: false,
  zoom: isMobile ? mobileZoom : 5,
  cropMode: false
}
